import React from 'react';

import RufsError from '../errors/rufsError.jsx';

const ApproveDiscountError = () => (
    <RufsError>
        Vi kan ikke godkjenne avslaget akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default ApproveDiscountError;



// WEBPACK FOOTER //
// ./safeTrade/resolution/approveDiscountError.jsx